import { useForm } from 'react-hook-form';
import { addNarrativeRequest } from 'utilitys/narrative/narrativeTools';
import { WidgetViewModeUtils } from 'utilitys/reporting/widgetViewModeUtils';

import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { useQueryGetKeyActivities } from 'api/queries/getKeyActivities.query';
import { useQueryGetKeyActivitiesTags } from 'api/queries/getKeyActivitiesTags.query';

import { usePinboardWidgetWrapperContext } from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/context/widgetWrapperContext';
import { statusOptions } from 'components/widgets/KeyActivities/components/filter.utils';

export interface FormProps {
    name: string;
    status: ISelectOption<string>[];
    moreFilter: ISelectOption<string>[];
    nextDate: ISelectOption<string>;
    tags: readonly ISelectOption<number>[];
}

export const useKeyActivitiesProvider = ({
    componentKey,
    widgetId,
    contractId,
    latestVersionId,
    compareVersionId,
    globalFilterData,
    localFilters,
    widgetViewMode,
    endpoints,
}) => {
    const { isGenerativeAi, reportId } = usePinboardWidgetWrapperContext();
    const getKeyActivitiesTagsPayload = { contractId };
    const getKeyActivitiesTags = useQueryGetKeyActivitiesTags(getKeyActivitiesTagsPayload);
    const isInPinboard = Boolean(widgetId);

    const form = useForm<FormProps>({
        defaultValues: {
            tags: WidgetViewModeUtils.isReportEditWidget(widgetViewMode) ? localFilters?.tags : [],
            name: WidgetViewModeUtils.isReportEditWidget(widgetViewMode) ? localFilters?.name : '',
            status: WidgetViewModeUtils.isReportEditWidget(widgetViewMode)
                ? localFilters?.status
                : statusOptions.filter((item) => item.id !== 3),
            moreFilter: WidgetViewModeUtils.isReportEditWidget(widgetViewMode) ? localFilters?.moreFilter : [],
            nextDate: WidgetViewModeUtils.isReportEditWidget(widgetViewMode)
                ? localFilters?.nextDate
                : {
                      label: 'ALL',
                      value: '-1',
                  },
        },
    });
    const formValues = form.watch();

    const source = WidgetViewModeUtils.isReportOrPinboardView(widgetViewMode)
        ? localFilters
        : { ...globalFilterData, ...formValues };

    const getKeyActivitiesPayload = {
        contractId: contractId,
        latestVersionId: latestVersionId,
        compareVersionId: compareVersionId,
        filterData: {
            filters: [],
        },
        tagIdList: source?.tags?.map((item) => item.value) || [],
        ...addNarrativeRequest(isGenerativeAi, componentKey, widgetId, reportId),
    };

    const getKeyActivities = useQueryGetKeyActivities(getKeyActivitiesPayload, endpoints.getKeyActivities);

    const pillsData = {
        tags: source?.tags?.map((i) => i.label),
        name: source?.name,
        statusFilter: source?.status?.map((item) => item.label),
        status: source?.moreFilter?.map((i) => i.label),
        numOfMonths: source?.nextDate?.label,
    };
    const { pillsList: pills } = useGlobalFiltersHook({ widgetId, source: pillsData, latestVersionId });

    return {
        ui: {
            state: { ...source },
            pills,
            form,
            isInPinboard,
        },
        api: {
            getKeyActivitiesTags: {
                instance: getKeyActivitiesTags,
                payload: getKeyActivitiesTagsPayload,
            },
            getKeyActivities: {
                instance: getKeyActivities,
                payload: getKeyActivitiesPayload,
                endpoint: endpoints.getKeyActivities,
            },
        },
    };
};
